const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScrewdriver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4.53914V3.83203H3.70711L10.5 10.6249L12.137 8.98795L13.4013 11.5166L19.7805 16.9144C20.1874 17.1341 20.6836 17.5754 20.8373 18.2452C21.0062 18.9811 20.7245 19.8146 19.8536 20.6856C18.9826 21.5565 18.1491 21.8383 17.4132 21.6694C16.7434 21.5156 16.302 21.0195 16.0824 20.6125L10.6846 14.2333L8.15592 12.969L9.79289 11.332L3 4.53914ZM11.863 10.6761L12.5987 12.1474L19.2228 17.7524L19.2764 17.7792C19.5268 17.9044 19.7903 18.1535 19.8627 18.4689C19.9271 18.7496 19.8755 19.2494 19.1464 19.9785C18.4174 20.7075 17.9176 20.7591 17.6368 20.6947C17.3215 20.6223 17.0724 20.3588 16.9472 20.1084L16.9204 20.0548L11.3154 13.4307L9.84408 12.6951L11.863 10.6761Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrewdriver);
export default __webpack_public_path__ + "static/media/screwdriver.d9eec6e2b1927adb4a75d84f1bc858f6.svg";
export { ForwardRef as ReactComponent };